"use strict";
import s from "underscore.string";
import React from "react";
import "../../api/api";
import classNames from "classnames";
import "../../formatters/general";
import PossibleAdjustments from "./possible_adjustments";
import _ from "underscore";
function onDragStart(e) {
  e.dataTransfer.effectAllowed = "copy";
  e.dataTransfer.setData("text/plain", e.target.value);
}
function invoiceAmount(invoice) {
  var amount = parseFloat(invoice.source_invoice_amount);
  return isNaN(amount) ? 0 : amount;
}
var InvoiceExpectedAmount = React.createClass({
  getInitialState: function() {
    return {};
  },
  render: function() {
    const currency = this.getDisplayCurrency();
    var classes = "small-9 columns";
    var afterAmount = null;
    if (currency) {
      classes = "small-7 columns";
      afterAmount = /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("span", { className: "postfix" }, currency));
    }
    return /* @__PURE__ */ React.createElement("div", { "data-component": "InvoiceExpectedAmount" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__invoice-document-info-label" }, /* @__PURE__ */ React.createElement("label", null, "Expected Amount")), /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 columns" }, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, "$")), /* @__PURE__ */ React.createElement("div", { className: classes }, this.expectedAmountBox(), this.possibleAmountAdjustments()), afterAmount));
  },
  getDisplayCurrency: function() {
    var _a;
    const loadPayables = this.props.load.load.tms_carrier_payables;
    if (((_a = this.carrierInvoice()) == null ? void 0 : _a.tms_carrier_payable_id) == null || loadPayables.length < 1) {
      return this.props.load.load.currency;
    } else {
      const matchingPayable = loadPayables.find(
        (x) => x.id === this.carrierInvoice().tms_carrier_payable_id
      );
      return matchingPayable && matchingPayable.currency;
    }
  },
  expectedAmountBox: function() {
    var actual = this.actualTotal();
    var sourceAmount = this.props.sourceInvoiceAmount || 0;
    if (this.carrierInvoice().quickpay_disposition === "applied_to_invoice") {
      var match = parseFloat(actual).toFixed(2) === (parseFloat(sourceAmount) + parseFloat(this.props.quickpayDiscountAmount)).toFixed(2);
    } else {
      var match = parseFloat(actual).toFixed(2) === parseFloat(sourceAmount).toFixed(2);
    }
    if (this.createdInHubTran()) {
      var classes = classNames({});
    } else {
      var classes = classNames({
        "load-detail__info-data-error": !match,
        "load-detail__info-data-match": match
      });
    }
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        readOnly: true,
        draggable: true,
        onDragStart,
        className: classes,
        value: this.formattedAmount(actual)
      }
    );
  },
  createdInHubTran() {
    return !_.isEmpty(this.load()) && this.load().load.source_system === "hubtran";
  },
  formattedAmount(amount) {
    if (this.createdInHubTran() || amount === 0) {
      return "-";
    } else {
      return s.numberFormat(Math.abs(parseFloat(amount)), 2);
    }
  },
  hasAmountAdjustments: function() {
    return this.hasOtherInvoiceAdjustments() || this.hasAdjustments();
  },
  possibleAmountAdjustments: function() {
    if (this.hasAmountAdjustments()) {
      return /* @__PURE__ */ React.createElement(
        PossibleAdjustments,
        {
          forExpectedAmount: true,
          expectedTotal: this.expectedTotal(),
          load: this.load(),
          carrierInvoice: this.carrierInvoice()
        }
      );
    }
  },
  actualTotal: function() {
    var adjusted = this.expectedTotal();
    if (this.hasOtherInvoiceAdjustments()) {
      adjusted -= this.otherInvoicesAdjustment();
    }
    if (this.hasAdjustments()) {
      adjusted -= this.otherAdjustment();
    }
    return adjusted <= 0 ? 0 : adjusted;
  },
  otherAdjustment: function() {
    if (this.hasAdjustments()) {
      return _.chain(this.adjustments()).pluck("amount").map(parseFloat).reduce((memo, num) => memo + num, 0).value();
    } else {
      return 0;
    }
  },
  hasAdjustments: function() {
    return !_.isEmpty(this.adjustments());
  },
  adjustments: function() {
    return this.load().load.tms_adjustments;
  },
  hasOtherInvoiceAdjustments: function() {
    return this.isDraftStatus() && this.otherInvoices().length > 0;
  },
  otherInvoicesAdjustment: function() {
    if (this.hasOtherInvoiceAdjustments()) {
      return _.chain(this.otherInvoices()).map(invoiceAmount).reduce((memo, num) => memo + num, 0).value();
    } else {
      return 0;
    }
  },
  expectedTotal: function() {
    return this.props.expectedTotal;
  },
  isDraftStatus: function() {
    return this.carrierInvoice().state === "draft";
  },
  otherInvoices: function() {
    return _.chain(this.load().carrier_invoices).filter((ci) => {
      return ci.id !== this.carrierInvoice().id;
    }).filter(function(ci) {
      return ci.state !== "deleted";
    }).filter(function(ci) {
      return ci.state !== "abandoned";
    }).filter((ci) => {
      return this.props.use_carrier_charge || ci.carrier_id === this.carrierInvoice().carrier_id;
    }).filter((ci) => {
      return invoiceAmount(ci) !== 0;
    }).value();
  },
  load: function() {
    return this.props.load;
  },
  carrierInvoice: function() {
    return this.props.carrierInvoice;
  }
});
export default InvoiceExpectedAmount;
